import React from 'react';

import { images } from '../../../../assets/images';

import BroadcastMetricsHeader from './BroadcastMetricsHeader';

import { useNavigate, useParams } from 'react-router-dom';
import { useAspSelector } from '../../../../test/jest-redux-hooks';

const BroadcastMetricsList = () => {
  const navigate = useNavigate();
  const { broadcastId } = useParams();
  const { currentBrand } = useAspSelector((state) => state.app);

  // Fetch broadcast details if needed
  const [broadcastData, setBroadcastData] = React.useState(null);

  React.useEffect(() => {
    // You can fetch broadcast details here if needed
    // For now, we'll pass the broadcastId to the header component
  }, [broadcastId, currentBrand?.brand_id]);

  const handleBackClick = () => {
    navigate('/user/broadcasts');
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    let hours = date.getHours();
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const period = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;
    return `${month} ${day}, ${hours}:${minutes} ${period}`;
  };

  return (
    <div className="campaignHeader-container w-100">
      <div className="campaignHeader-wrapper flex-row align-center">
        <div className="flex-row align-center">
          <img
            src={images?.CampaignBackIcon}
            alt="backIcon"
            onClick={handleBackClick}
            className="pr-10 pl-10 pointer"
          />
        </div>

        <div className="border-left flex-column p-10">
          <div className="flex-row align-center pointer">
            <span className="campaignHeader-campaign">
              {broadcastData?.name || 'Broadcast'}
            </span>
            <div className="Awareness flex-row align-center">
              <span className="">Broadcast</span>
            </div>
          </div>
          <div className=" campaignUpdates flex-row">
            <span>Created @</span>
            <span className="pl-5">
              {formatDate(broadcastData?.created_at)}
            </span>
          </div>
        </div>
      </div>
      <BroadcastMetricsHeader
        broadcastId={broadcastId}
        onBroadcastDataLoaded={setBroadcastData}
      />
    </div>
  );
};

export default BroadcastMetricsList;
